var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3H17.73C17.1 1.26 15.45 0 13.5 0C11.55 0 9.9 1.26 9.27 3H3C1.35 3 0 4.35 0 6V27C0 28.65 1.35 30 3 30H24C25.65 30 27 28.65 27 27V6C27 4.35 25.65 3 24 3ZM13.5 3C14.325 3 15 3.675 15 4.5C15 5.325 14.325 6 13.5 6C12.675 6 12 5.325 12 4.5C12 3.675 12.675 3 13.5 3ZM6 9H21V6H24V27H3V6H6V9ZM13.5 24V21H21V24H13.5ZM13.5 15V12H21V15H13.5ZM7.5 16.5V12H6V10.5H9V16.5H7.5ZM9.375 19.5C9.99 19.5 10.5 20.01 10.5 20.625C10.5 20.925 10.38 21.21 10.185 21.405L7.68 24H10.5V25.5H6V24.12L9 21H6V19.5H9.375Z",
    fill: "#AAAFBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.f4e0c69c4692e2612ecbdd85b41ec324.svg";
export { ForwardRef as ReactComponent };